import FadeIn from 'legacy/common/components/transition/FadeIn';
import { useGetOffers } from 'legacy/events/hooks';
import React, { useState } from 'react';
import OfferCard from '../../offers/OfferCard';
import OfferActionModal from '../../offers/modals/OfferActionModal';
import PromoterActionModal from '../../offers/modals/PromoterActionModal';
import PausePromoterModal from '../../offers/modals/PausePromoterModal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { OffersPageProps, OffersStep } from 'legacy/events/offers.types';

const OffersList = ({ eventId, setOffersStep }: OffersPageProps) => {
  const { data } = useGetOffers(eventId, { enabled: !!eventId });

  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [isPromoterActionModalOpen, setIsPromoterActionModalOpen] =
    useState(false);
  const [isPausePromoterModalOpen, setIsPausePromoterModalOpen] =
    useState(false);

  return (
    <>
      <FadeIn>
        <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:w-[630px] md:mx-auto md:px-0 px-4">
          <div className="my-4">
            <div className="font-bold text-base text-[#202020]">
              Available Offers
            </div>
            {data?.offers?.map((offer) => (
              <div className="mt-4" key={offer.id}>
                <OfferCard offer={offer} />
              </div>
            ))}
          </div>
        </div>
      </FadeIn>
      {isActionModalOpen && (
        <OfferActionModal onClose={() => setIsActionModalOpen(false)} />
      )}
      {isPromoterActionModalOpen && (
        <PromoterActionModal
          onClose={() => setIsPromoterActionModalOpen(false)}
        />
      )}
      {isPausePromoterModalOpen && (
        <PausePromoterModal
          onClose={() => setIsPausePromoterModalOpen(false)}
        />
      )}
      <div className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4">
        <div className="w-full md:w-[343px] mx-auto">
          <div className="flex gap-4">
            <Button
              type={ButtonType.Primary}
              onClick={() => setOffersStep(OffersStep.CREATE_OFFER)}
            >
              <div className="flex items-center justify-center">
                Create offer
              </div>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffersList;
